import { useState, useEffect } from "react";
import AdminShell from "./AdminShell";
import DataTable from "./components/DataTable";
import { adminViewComments } from "./api";

const COLUMNS = [
  { key: "sp_id", label: "User ID" },
  { key: "when", label: "When" },
  { key: "description", label: "Comment" },
];

const normalize = (row) => ({
  sp_id: row.sp_id,
  when: row.when ?? "",
  description: row.description,
});

export default function AdminViewComments() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await adminViewComments();
        const data = Array.isArray(res.data) ? res.data : [];
        const valid = data.filter((r) => r.description && r.table !== "Comments are Empty");
        setRows(valid.map(normalize));
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  return (
    <AdminShell title="All comments">
      <DataTable caption="Comments left for users" columns={COLUMNS} rows={rows} emptyLabel="No comments yet." />
    </AdminShell>
  );
}
